import { sammelnClient } from '@xver/libs/axios';

import {
    CreateWebhookRequest,
    DeleteWebhookResponse,
    ListWebhooksResponse,
    SupportedEventTypesResponse,
    UpdateWebhookRequest,
    WebhookResponse,
} from './model';

const ENDPOINTS = {
    LIST: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/webhooks`,
    CREATE: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/webhooks`,
    EVENTS: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/webhooks/events`,
    GET: (projectIdOrName: string, id: number) => `/v1/projects/${projectIdOrName}/webhooks/${id}`,
    UPDATE: (projectIdOrName: string, id: number) =>
        `/v1/projects/${projectIdOrName}/webhooks/${id}`,
    DELETE: (projectIdOrName: string, id: number) =>
        `/v1/projects/${projectIdOrName}/webhooks/${id}`,
};

export function listWebhooks(projectIdOrName: string): Promise<ListWebhooksResponse> {
    return sammelnClient.get(ENDPOINTS.LIST(projectIdOrName));
}

export function getWebhook(projectIdOrName: string, id: number): Promise<WebhookResponse> {
    return sammelnClient.get(ENDPOINTS.GET(projectIdOrName, id));
}

export function getSupportedEventTypes(
    projectIdOrName: string
): Promise<SupportedEventTypesResponse> {
    return sammelnClient.get(ENDPOINTS.EVENTS(projectIdOrName));
}

export function createWebhook(
    projectIdOrName: string,
    data: CreateWebhookRequest
): Promise<WebhookResponse> {
    return sammelnClient.post(ENDPOINTS.CREATE(projectIdOrName), data);
}

export function updateWebhook(
    projectIdOrName: string,
    id: number,
    data: UpdateWebhookRequest
): Promise<WebhookResponse> {
    return sammelnClient.put(ENDPOINTS.UPDATE(projectIdOrName, id), data);
}

export function deleteWebhook(projectIdOrName: string, id: number): Promise<DeleteWebhookResponse> {
    return sammelnClient.delete(ENDPOINTS.DELETE(projectIdOrName, id));
}
